// extracted by mini-css-extract-plugin
export default {"button":"CopyAddressButton_button__MjtBQ"};